import { InjectionToken } from '@angular/core';
import { Duration } from 'moment';
import { Observable } from 'rxjs';
import { EscalationModel } from '../components/escalation/escalation.model';
import { NotificationModel } from '../models/low-level/notification.model';

export interface EscalationInterface {
    setTimerForEscalation(notification: NotificationModel, durationPassed: Duration): void;
    removeEscalationTimer(notification: NotificationModel): void;
    checkEscalationRequired(): void;
    saveEscalationStatus(escalation: EscalationModel, notification: NotificationModel): Observable<void>;
    showEscalationPopup(notification: NotificationModel): void;
}

/**
 * DI token for {@link EscalationInterface}. Lets the app choose which implementation to
 * provide (legacy `EscalationService` or the NgRx-backed `EscalationNgrxService`) without
 * consumers depending on a concrete class.
 */
export const EscalationInstanceToken = new InjectionToken<EscalationInterface>('EscalationInterface');
